export default __webpack_public_path__ + "static/media/D3.153d6248.png";